import React, { useEffect, useState, useContext } from "react";
import { PaystackButton } from "react-paystack";
import { useRouter } from "next/router";
// Hooks
import useAuth from "@/hooks/useAuth";
import styled from "styled-components";
import Script from "next/script";

type referenceObj = {
  message: string;
  reference: string;
  status: "sucess" | "failure";
  trans: string;
  transaction: string;
  trxref: string;
};

interface Detail {
  country: string | null;
  toggle: () => void;
  period: string;
  amount: number;
  displayName: string;
}
const PaystackPayment = ({
  country,
  toggle,
  period,
  amount,
  displayName,
}: Detail) => {
  const publicKey = process.env.NEXT_PUBLIC_PAYSTACK_PUBLIC_TEST_KEY || "";
  const user = useAuth();
  const router = useRouter();

  const getLink = (period: string, amount: number) => {
    if (period === "Resume") {
      if (amount === 21) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/7d550bf8-3d9c-45f0-985b-f58f8437d4ab";
      } else if (amount === 80) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/0acc4692-b699-48f5-8954-f911b4265f93";
      } else if (amount === 140) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/4d5ecd39-1076-46db-a53c-0b35d4a42fee";
      } else if (amount === 200) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/8db1432f-6491-4fba-ac38-9292ba36b07e";
      }
    }
    if (period === "CoverLetter") {
      if (amount === 21) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/981844ff-5734-4058-a3f9-8085468a372d";
      } else if (amount === 80) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/3f229685-f306-46c6-966a-ec634c155bb3";
      } else if (amount === 140) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/b7a5fd4d-08f4-4f9b-82a9-f2f66536b5b4";
      } else if (amount === 200) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/3ac33fb3-43d3-4b05-b91e-6aac6c1d2d71";
      }
    }
    if (period === "Email") {
      if (amount === 21) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/b91eee40-6f93-4b5d-905a-adc08e2460b6";
      } else if (amount === 80) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/b9edfa5c-bd2a-46af-acc0-e98d7e660f48";
      } else if (amount === 140) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/c5962edc-dc8a-4b56-92f5-947d489364f1";
      } else if (amount === 200) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/f9acf724-be36-427f-be9c-764954e335f6";
      }
    }
    if (period === "Tracker") {
      if (amount === 21) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/5865f268-8cea-4a30-9964-277d9dd2956c";
      } else if (amount === 80) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/b6181331-1b58-42ec-9578-f5969c9d7a07";
      } else if (amount === 140) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/a590f6ff-1c4b-4626-affa-d132fe9ada58";
      } else if (amount === 200) {
        return "https://instantapply.lemonsqueezy.com/checkout/buy/fc62f109-5df3-4caa-a4c4-0023347c7430";
      }
    }
  };

  const config = {
    reference: new Date().getTime().toString(),
    email: user && user.email ? user.email : "",
    publicKey: publicKey,
    amount: amount,
    metadata: {
      custom_fields: [
        {
          display_name: displayName,
          variable_name: displayName,
          value: amount,
        },
      ],
    },
  };

  const handlePaystackCloseAction = () => {
    // implementation for  whatever you want to do when the Paystack dialog closed.
  };
  const onSuccess = async (reference: referenceObj) => {
    const download = await fetch("/api/paystack", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(reference.reference),
    }) ;

    const data = await download.json();

    //prevents it from immediately redirecting back to home
    if (data.message === "Verification successful") {
      setTimeout(() => {
        router.push("/");
      }, 200);
    }
  };
  const componentProps = {
    ...config,
    text: "Get Credits",
    onSuccess: (reference: any) => onSuccess(reference),
    onClose: handlePaystackCloseAction,
  };

  const submit = async (e: { preventDefault: () => void }) => {
    router.push("/signin");
    return;

    // const download = await fetch("/api/paystackinitialize", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify(config),
    // });

    // const result = await download.json()
    // console.log(result,"pp")
    // onSuccess(result.data);
  };

  //fix to enable Supabase user

  return (
    <div className="App">
      <div className="container">
        <div className="item"></div>
        <div className="checkout-form font-silka">
          {country === "Nigeria" ? (
            user ? (
              <div>
                <PaymentCta>
                  <PaystackButton
                    className="w-full h-full" 
                    {...componentProps}
                  />
                </PaymentCta>
              </div>
            ) : (
              <div onClick={submit}>
                <PaymentCta>Get Credits</PaymentCta>
              </div>
            )
          ) : (
            <div>
              {" "}
              {user ? (
                <a
                  href={getLink(period, amount)}
                  className="lemonsqueezy-button"
                >
                  <PaymentCta>
                    Get Credits
                    <Script
                      src="https://assets.lemonsqueezy.com/lemon.js"
                      defer
                    ></Script>
                  </PaymentCta>{" "}
                </a>
              ) : (
                <div onClick={submit}>
                  <PaymentCta>Get Credits</PaymentCta>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const PaymentCta = styled.div`
  width: 100%;
  font-size: 16px;
  padding: 0.8em 0;
  border: 1px solid #aaa;
  background-color: #fff;
  border-radius: 0.5em;
  text-align: center;
  margin-top: 1em;
  color: black !important;
  cursor: pointer;
`;

export default PaystackPayment;
